import React from "react";

const DisLike = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/2000/xlink"
    >
        <path
            d="M3.455 21.057h4.363V2.777H3.455c-.386 0-.756.161-1.029.447A1.56 1.56 0 0 0 2 4.3v15.233c0 .404.153.792.426 1.077.273.286.643.446 1.029.446Zm7.698 1.97 9.31 9.75a.704.704 0 0 0 .951.072l1.24-.976c.345-.271.605-.643.749-1.068.143-.426.162-.886.056-1.324l-1.677-6.9h9.309c.771 0 1.511-.321 2.057-.893A3.121 3.121 0 0 0 34 19.534V16.33c0-.398-.074-.792-.218-1.16L29.28 3.72a1.51 1.51 0 0 0-.536-.686 1.408 1.408 0 0 0-.81-.257H12.182c-.386 0-.756.16-1.029.446a1.56 1.56 0 0 0-.426 1.077V21.95c0 .404.154.791.426 1.077Z"
            className="u_fill"
            fill={fill}
        />
    </svg>
);

export default DisLike;


